module.exports = __webpack_public_path__ + "img/15000.3e17d97c.jpg";